/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import slick from '../vendors/slick.min';

jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}
} );

jQuery( function() {
	/**
	 * Toggle menu for mobile
	 */
	const navOverlay = jQuery( '.nav-overlay' );
	const htmlBody = jQuery( 'html, body' );

	const sections = [];
	jQuery( '.header-nav a[href^="#"]' ).each( function() {
		const id = jQuery( this ).attr( 'href' );
		if ( jQuery( id ).length ) {
			sections.push( {
				id,
				link: jQuery( this ),
			} );
		}
	} );

	function setActiveMenu( id ) {
		jQuery( '.header-nav li' ).removeClass( 'current-menu-item' );
		jQuery( '.header-nav a[href="' + id + '"]' ).closest( 'li' ).addClass( 'current-menu-item' );
	}

	jQuery( '.header-nav' ).on( 'click', 'a[href^="#"]', function( e ) {
		const link = jQuery( this );
		jQuery( '.menu-btn' ).removeClass( 'active' );
		navOverlay.removeClass( 'open' );
		htmlBody.removeClass( 'no-overflow' );
		link.closest( 'ul' ).find( 'ul.sub-menu' ).slideUp();

		const id = jQuery( this ).attr( 'href' );
		const target = jQuery( id );

		if ( target.length ) {
			e.preventDefault();

			jQuery( 'html, body' ).animate(
				{ scrollTop: target.offset().top - 130 },
				600
			);

			setActiveMenu( id );

			history.replaceState( null, null, window.location.pathname );
		}
	} );

	jQuery( window ).on( 'scroll', function() {
		const scrollTop = jQuery( window ).scrollTop();

		if ( scrollTop <= 1 ) {
			jQuery( '.header-nav li' ).removeClass( 'current-menu-item' );
			return;
		}

		const scrollPos = scrollTop + 150;

		for ( let i = sections.length - 1; i >= 0; i-- ) {
			const section = jQuery( sections[ i ].id );
			if ( section.offset().top <= scrollPos ) {
				setActiveMenu( sections[ i ].id );
				break;
			}
		}
	} );

	jQuery( '.menu-btn' ).on( 'click', function() {
		jQuery( this ).toggleClass( 'active' );
		navOverlay.toggleClass( 'open' );
		htmlBody.toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */

	jQuery( '.menu-item-has-children > a:first-child' ).each( function() {
		jQuery( this ).after( '<span class="submenu-icon"></span>' );
	} );

	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */

	jQuery( '.header-nav' ).on( 'click', '.submenu-icon', function() {
		const parentLi = jQuery( this ).closest( 'li' );

		parentLi.siblings( '.active' )
			.removeClass( 'active' )
			.find( 'ul' ).slideUp();

		parentLi.toggleClass( 'active' ).find( 'ul' ).stop( true, true ).slideToggle();
		parentLi.parents( 'ul' ).toggleClass( 'disabled-menu', parentLi.hasClass( 'active' ) );
	} );

	/**
	 *  Accessibility for Simple menu & Mega menu
	 */
	jQuery( '.menu-item-has-children > a' ).on( 'focus blur', function( event ) {
		jQuery( this ).siblings( '.sub-menu, .mega-menu' ).toggleClass( 'focused', event.type === 'focus' );
	} );

	jQuery( '.sub-menu a, .mega-menu a' ).on( 'focus blur', function( event ) {
		jQuery( this ).closest( '.sub-menu, .mega-menu' ).toggleClass( 'focused', event.type === 'focus' );
	} );

	/**
	 * Script for Accessibility of html Tags
	 */

	jQuery( 'h1, h2, h3, h4, h5, h6,p,li,blockquote,cite,strong,dt,dd,th,td,b,i,u,s,em,small,sup,del,ins,abbr,mark,details,pre,kbd,samp,var,address,code,q,figure,figcaption,caption,.top-bar-text,.top-bar-cross,.copy-right,.post-author-img,.post-author-name,.post-meta-date,.post-date' ).each( function() {
		jQuery( this ).attr( {
			tabindex: 0,
		} );
	} );

	// Stats Counter

	if ( jQuery( '.stat-title' ).length > 0 ) {
		const $statNumbers = jQuery( '.stat-title .heading-1' );
		function animateCounter( $element ) {
			const text = $element.text().trim();
			const numericText = text.match( /[0-9]+(?:\.[0-9]+)?/ )[ 0 ];
			const prefix = text.substring( 0, text.indexOf( numericText ) );
			const suffix = text.substring( text.indexOf( numericText ) + numericText.length );
			const targetValue = parseFloat( numericText );
			if ( isNaN( targetValue ) ) {
				return;
			}

			const startValue = 0;
			const duration = 3000;
			const totalFrames = duration / ( 1000 / 60 );
			const increment = ( targetValue - startValue ) / totalFrames;
			let animatedValue = startValue;

			const decimalPlaces = numericText.includes( '.' )
				? numericText.split( '.' )[ 1 ].length
				: 0;

			const updateCounter = () => {
				animatedValue += increment;
				if ( animatedValue >= targetValue ) {
					$element.text(
						prefix + targetValue.toFixed( decimalPlaces ) + suffix,
					);
				} else {
					$element.text(
						prefix + animatedValue.toFixed( decimalPlaces ) + suffix,
					);
					requestAnimationFrame( updateCounter );
				}
			};
			requestAnimationFrame( updateCounter );
		}

		const isInViewport = ( element ) => {
			const rect = element[ 0 ].getBoundingClientRect();
			return (
				rect.bottom >= 0 &&
				rect.top <=
				( window.innerHeight ||
					document.documentElement.clientHeight )
			);
		};

		jQuery( window )
			.on( 'scroll resize', () => {
				$statNumbers.each( function() {
					const $this = jQuery( this );
					if ( isInViewport( $this ) && ! $this.hasClass( 'animated' ) ) {
						animateCounter( $this );
						$this.addClass( 'animated' );
					}
				} );
			} )
			.trigger( 'scroll' );
	}
	jQuery.noConflict();

	jQuery( '.header-nav li, .blog-nav li, .footer-nav li, .legal-nav li' ).each( function() {
		const link = jQuery( this ).find( 'a' );
		if ( link.length > 0 ) {
			jQuery( this ).removeAttr( 'tabindex' );
		} else {
			jQuery( this ).attr( 'tabindex', '0' );
		}
	} );

	jQuery( 'form p' ).each( function() {
		jQuery( this ).removeAttr( 'tabindex' );
	} );

	jQuery( 'a,button:not([href])' ).each( function() {
		jQuery( this ).attr( {
			tabindex: 0,
		} );
	} );

	setTimeout( () => {
		jQuery( '#daextlwcnf-cookie-notice-button-1' ).attr( 'role', 'button' );
		jQuery( '#daextlwcnf-cookie-notice-button-2' ).attr( 'role', 'button' );
		jQuery( '#daextlwcnf-cookie-settings-button-1' ).attr( 'role', 'button' );
		jQuery( '#daextlwcnf-cookie-settings-button-2' ).attr( 'role', 'button' );
	}, 500 );

	autosize();
	function autosize() {
		const text = jQuery( 'textarea' );

		text.each( function() {
			jQuery( this ).attr( 'rows', 5 );
			resize( jQuery( this ) );
		} );

		text.on( 'input', function() {
			resize( jQuery( this ) );
		} );

		function resize( $text ) {
			$text.css( 'min-height', 'auto' );
			$text.css( 'min-height', $text[ 0 ].scrollHeight + 'px' );
		}
	}

	jQuery( '.footer-slider' ).slick( {
		autoplay: true,
		autoplaySpeed: 0,
		speed: 5000,
		arrows: false,
		swipe: false,
		slidesToShow: 4,
		variableWidth: true,
		cssEase: 'linear',
		pauseOnFocus: false,
		pauseOnHover: false,
	} );

	jQuery( '.banner-image-slider' ).slick( {
		autoplay: true,
		autoplaySpeed: 5000,
		speed: 1000,
		arrows: false,
		swipe: false,
		slidesToShow: 1,
		cssEase: 'linear',
		pauseOnFocus: false,
		pauseOnHover: false,
		dots: true,
		fade: true,
	} );

	if ( jQuery( '.steps-slider' ).length > 0 ) {
		const $slider = jQuery( '.steps-slider' );
		const $prev = jQuery( '.step-prev' );
		const $nextImage = jQuery( '.step-next' );

		$slider.on( 'init reInit afterChange', function( e, slick, currentSlide ) {
			const index = currentSlide || 0;
			const total = slick.slideCount;

			if ( index === 0 ) {
				$prev.addClass( 'disabled' );
			} else {
				$prev.removeClass( 'disabled' );
			}

			if ( index === total - 1 ) {
				$nextImage.addClass( 'disabled' );
			} else {
				$nextImage.removeClass( 'disabled' );
			}
		} );

		$slider.slick( {
			arrows: true,
			prevArrow: jQuery( '.step-prev' ),
			nextArrow: jQuery( '.step-next' ),
			swipe: true,
			slidesToShow: 1,
			cssEase: 'linear',
			pauseOnFocus: false,
			pauseOnHover: false,
			dots: true,
			appendDots: jQuery( '.steps-dots' ),
			fade: true,
			speed: 100,
		} );
	}

	if ( jQuery( '.images-slider' ).length > 0 ) {
		const $sliderImages = jQuery( '.images-slider' );
		const $prevImage = jQuery( '.slide-prev' );
		const $nextImage = jQuery( '.slide-next' );

		$sliderImages.on( 'init reInit afterChange', function( e, slick, currentSlide ) {
			const index = currentSlide || 0;
			const lastIndex = slick.slideCount - slick.options.slidesToShow;

			if ( index <= 0 ) {
				$prevImage.addClass( 'disabled' );
			} else {
				$prevImage.removeClass( 'disabled' );
			}

			if ( index >= lastIndex ) {
				$nextImage.addClass( 'disabled' );
			} else {
				$nextImage.removeClass( 'disabled' );
			}
		} );

		$sliderImages.slick( {
			slidesToShow: 4,
			slidesToScroll: 1,
			cssEase: 'linear',
			pauseOnFocus: false,
			pauseOnHover: false,
			touchThreshold: 200,
			variableWidth: true,
			infinite: false,
			arrows: true,
			speed: 300,
			prevArrow: $prevImage,
			nextArrow: $nextImage,
			responsive: [
				{
					breakpoint: 1184,
					settings: {
						slidesToShow: 3,
					},
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		} );
	}

	if ( jQuery( '.package-tabs' ).length > 0 ) {
		jQuery( '.package-tabs button.package-tab' ).on( 'click', function() {
			const tabTarget = jQuery( this ).data( 'tab-target' );
			jQuery( '.package-tabs .package-tab' ).removeClass( 'current-tab' );
			jQuery( this ).addClass( 'current-tab' );
			jQuery( '.tab-content' )
				.stop( true, true )
				.hide()
				.removeClass( 'current' );
			jQuery( '#' + tabTarget )
				.stop( true, true )
				.fadeIn( 300 )
				.addClass( 'current' )
				.find( '.monthly-packages, .yearly-packages' )
				.slick( 'refresh' );
		} );

		const indicator = document.querySelector( '.nav-indicator' );
		const items = document.querySelectorAll( '.package-tabs button' );
		const list = document.querySelector( '.package-tabs' );

		function handleIndicator( el ) {
			items.forEach( ( item ) => {
				item.classList.remove( 'is-active' );
				item.removeAttribute( 'style' );
			} );
			const listRect = list.getBoundingClientRect();
			const elRect = el.getBoundingClientRect();
			indicator.style.width = `${ elRect.width }px`;
			indicator.style.left = `${ elRect.left - listRect.left }px`;
			el.classList.add( 'is-active' );
		}

		items.forEach( ( item ) => {
			item.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				handleIndicator( item );
			} );

			if ( item.classList.contains( 'is-active' ) ) {
				handleIndicator( item );
			}
		} );
	}

	jQuery( document ).on( 'click', '.faq-head', function() {
		const parent = jQuery( this ).closest( '.single-faq' );
		if ( jQuery( this ).hasClass( 'active' ) ) {
			jQuery( '.faq-head' ).removeClass( 'active' );
			jQuery( '.single-faq' ).removeClass( 'active' );
			jQuery( '.faq-content' ).slideUp( 400 );
		} else {
			jQuery( '.faq-head' ).removeClass( 'active' );
			jQuery( '.single-faq' ).removeClass( 'active' );
			jQuery( '.faq-content' ).slideUp( 400 );

			jQuery( this ).addClass( 'active' );
			parent.addClass( 'active' );
			parent.find( '.faq-content' ).slideDown( 400 );
		}
	} );

	jQuery( '.popup-modal' ).magnificPopup( {
		type: 'inline',
		preloader: false,
		closeOnBgClick: true,
		enableEscapeKey: true,
	} );

	jQuery( document ).on( 'click', '.popup-modal-dismiss', function( e ) {
		e.preventDefault();
		jQuery.magnificPopup.close();
	} );

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.monthly-packages, .yearly-packages' ).slick( {
			arrows: false,
			dots: true,
			swipe: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			cssEase: 'linear',
			infinite: false,
			pauseOnFocus: false,
			pauseOnHover: false,
			fade: true,
		} );

		function equalSlickHeight( slider ) {
			let maxHeight = 0;

			jQuery( slider ).find( '.slick-slide:not(.slick-cloned)' ).each( function() {
				const h = jQuery( this ).outerHeight( true );
				if ( h > maxHeight ) {
					maxHeight = h;
				}
			} );

			jQuery( slider ).find( '.slick-track' ).height( maxHeight );
		}

		jQuery( '.monthly-packages, .yearly-packages' ).on( 'setPosition', function() {
			equalSlickHeight( this );
		} );

		jQuery( window ).on( 'load', function() {
			jQuery( '.monthly-packages, .yearly-packages' ).slick( 'setPosition' );
		} );

		jQuery( '.videos-columns.four-columns' ).slick( {
			arrows: false,
			dots: true,
			swipe: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			cssEase: 'linear',
			infinite: false,
			pauseOnFocus: false,
			pauseOnHover: false,
			responsive: [
				{
					breakpoint: 1184,
					settings: {
						slidesToShow: 3,
					},
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		} );
	}
} );

